import { Loader } from 'src/design/atoms/Loader';
import React from 'react';
import { PostDto } from 'src/api/FiretrolApiClient';
import { usePost } from 'src/api/queries/posts/usePost';
import { useForceReadPostNotification } from 'src/api/queries/userNotifications/useUserNotificationMutations';
import { Alert } from 'src/design/atoms/Alert';
import { Modal } from 'src/design/molecules/Modal';
import { getErrorMessage } from 'src/utils';
import { PostItem } from 'src/routes/Jobs/ActivityFeed/components/PostItem';

interface PostViewDialogProps {
  postId: string | null;
  jobId: number;
  open: boolean;
  onClose: () => void;
  openEditDialog: (item: PostDto) => void;
}

export const PostViewDialog: React.FC<PostViewDialogProps> = ({
  postId,
  jobId,
  open,
  onClose,
  openEditDialog,
}) => {
  const { data: post, isLoading, error } = usePost(jobId, postId);
  const { mutate: markRead } = useForceReadPostNotification();

  React.useEffect(() => {
    // Post ID overrides the notification ID
    if (post && postId) markRead(postId);
  }, [post, postId, markRead]);

  return (
    <Modal opened={open} onClose={onClose} title="Post Details" size="xl">
      {isLoading && <Loader />}
      {error && <Alert color="red">{getErrorMessage(error)}</Alert>}
      {!isLoading && !error && post && (
        <PostItem item={post} openEditDialog={openEditDialog} jobId={jobId} />
      )}
    </Modal>
  );
};
